const SCREW_WIDTH = 40;
export default class {
    static getMods(width) {
        const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
        let mods = Math.floor(width / baseWidth);
        if (mods > 10) {
            mods = 10
        }
        if (!mods) mods = 1;
        return mods;
    }

    static getHeight = (device) => {
        if (device.type == 'generic') {
            return SIZE.baseHeight * device.height / 100 || SIZE.baseHeight
        }
        return SIZE.baseHeight
    }

    static getTextPadding = (device, DEFAULT_PADDING) => { // see generic device
        return DEFAULT_PADDING;
    }


    static getWidth = (device) => {
        const width = device.width ? device.width : 0
        return width * SIZE.pxInMm;
    }

    static getContainerHeight = (height, scale) => {
        return height / scale;
    }

    static getRect(width, height) {
        return `<rect stroke="#212121" x="1.518" y="1.52" width="${width ? width - 2.75 : 0}" height="${height ? height - 3 : 0}" stroke-width="3" rx="6" ry="6" style="display:inline"/>`
    }

    static isBlack(device) {
        return device.bgColor == COLORS.black || device.bgColor == '#' + COLORS_RGB.black
    }

    static getDevice(device, scale, customParts = "", disableLines = false, forceDisapleWidthText = false) {


        const WIDTH = this.getWidth(device)
        // const WIDTH = Math.round(this.getWidth(device) * 100) / 100;

        const HEIGHT = this.getHeight(device);
        const containerHeight = this.getContainerHeight(HEIGHT, scale);
        const text = device.moduleText ? device.moduleText : (device.busText ? device.busText : (device.inputText ? device.inputText : ""))
        // const fontColor = this.isBlack(device) ? '#ffffff' : '#212121'
        const fontColor = '#212121'



        return `<svg fill="${device.bgColor || '#fff'}" width="${WIDTH / scale}" height="${containerHeight}" stroke-linejoin="round" stroke-linecap="round" stroke="#000" fill-rule="evenodd" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${WIDTH} ${HEIGHT}" ${this.getFlip(device)}>
${this.getRect(WIDTH, HEIGHT)}
${disableLines ? "" : `<path fill="none" stroke="#212121" stroke-width="3" d="M2.698 80.553h${WIDTH}M2.699 230h${WIDTH}"/>`}
${this.getPorts(device, 'top')}
${this.getPorts(device, 'top2')}
${this.getPorts(device, 'bottom2')}
${this.getPorts(device, 'bottom')}
${customParts || ""}
</defs>
${STORAGE.getSetting('displayModuleWidth') && !forceDisapleWidthText ? `<text opacity="0.6" ${this.getFlip(device)} x="${device.flip ? "-" : ""}50%" y="${this.getTextPadding(device, 15)}" class="svgTextSmall" filter="url(#bg)" dominant-baseline="middle" text-anchor="middle" fill="#212121" stroke="#212121">${device.width}мм</text>` : ''}
${this.printText(device, fontColor, text)}
${this.printCurrent(device, fontColor)}<style>
  .svgText {          
      font:  22px Arial Narrow;       
  } .svgTextSmall {
    font-size: 15px;
    font-family: Arial Narrow;}
</style>
</svg>`.replace(/>\s+</g, '><')
    }
    static printText(device, fontColor, text) {
        if (!text) return;

        let className = "svgText";
        if (device.width < 10 && text.length > 1) {
            className = "svgTextSmall";
        }
        return `<text ${this.getFlip(device)} filter="url(#bg)" x="${device.flip ? "-" : ""}50%" y="${this.getTextPadding(device, 102)}" class="${className}" dominant-baseline="middle" text-anchor="middle" fill="${fontColor}" stroke="${fontColor}">${text}</text>`

    }

    static printCurrent(device, fontColor) {

        return `<text ${this.getFlip(device)} filter="url(#bg)" x="${device.flip ? "-" : ""}50%" y="${this.getTextPadding(device, 212)}" class="svgTextSmall" dominant-baseline="middle" text-anchor="middle" fill="${fontColor}" stroke="${fontColor}">${device.current ? device.current + "A" : ""}</text>`;
    }


    static getDefaultPortsCount = (widht, baseWidth) => {
        let res = Math.floor(widht / SIZE.pxInMm / baseWidth);
        if (res < 1) res = 1;
        return res;
    }

    static getFlip(device) {
        if (device.flip) {
            return ` transform="scale(-1,1)" `
        }
        return ""
    }

    static getPorts(device, position) {
        const height = this.getHeight(device);
        const width = this.getWidth(device);
        const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
        const KEY = `${position}Ports`

        if (typeof device[KEY] === 'undefined') {
            if (['top', 'bottom'].includes('position')) {
                device[KEY] = this.getDefaultPortsCount(width, baseWidth)
            }
            else {
                return 0;
            }

        }

        if (width / SIZE.pxInMm / device[KEY] < baseWidth / SIZE.maxPortsPerMod) {
            device[KEY] = Math.ceil(width / SIZE.pxInMm / baseWidth * SIZE.maxPortsPerMod)
        }

        let [screwWidth, spaceX] = this.getScrewWidthAndSpace(device, position);

        const y = this.getPortY(device, position, screwWidth, height);

        let res = ''

        for (var i = 0; i < device[KEY]; i++) {
            let x = spaceX + i * screwWidth + 2 * spaceX * i;
            res += `<image data-wire-direction="${this.getWireDirection(device, position)}" data-color="${this.getWireColor(device)}" width="${screwWidth}" height="${screwWidth}"  x="${x}" y="${y}" data-position="${position}" data-id="${this.getPortId(device, position, i)}" class="screw" href="${PARTS.screw}"/>`
        }
        return res;
    }

    static getWireColor = (device) => {
        return "";
    }

    static getWireDirection = () => {
        return "";
    }

    static getPortId = (device, position, i) => {
        let id = device.id
        switch (position) {
            case 'top': {
                id += '_t_'
                break
            }
            case 'top2': {
                id += '_t2_'
                break
            }
            case 'bottom2': {
                id += '_b2_'
                break
            }
            case 'bottom': {
                id += '_b_'
                break
            }
        }
        id += i
        return id;
        // ${device.id}_${position == 'top' ? "t" : "b"}_${i}
    }

    static getScrewWidthAndSpace = (device, position) => {
        const width = this.getWidth(device);
        const KEY = `${position}Ports`
        let screwWidth = SCREW_WIDTH;
        let spaceX = 0;
        while (true) { // reducing to fit width
            spaceX = (width - screwWidth * device[KEY]) / (device[KEY] * 2)
            if (spaceX <= 1.5) {
                screwWidth = screwWidth / 1.1;
                if (screwWidth <= 1) {
                    break;
                }
            }
            else {
                break;
            }
        }

        const height = this.getHeight(device);
        const rowsCount = this.getRowsCount(device);
        let spaceY = 0;
        let reducedY = false;
        while (true) { // reducing to fit height
            spaceY = (height - this.getScrewsPaddingY() * 2 - this.getRowsSpace() * rowsCount - screwWidth * rowsCount) / (rowsCount + 1)
            if (spaceY <= 1.5) {
                screwWidth = screwWidth / 1.1;
                reducedY = true
                if (screwWidth <= 1) {
                    break;
                }
            }
            else {
                break;
            }
        }

        if (reducedY) { // сейчас, после уменьшени размера болта по высоте надо снова пересчитать расстояния между болтами по горизонтали
            spaceX = (width - screwWidth * device[KEY]) / (device[KEY] * 2)
        }
        return [screwWidth, spaceX, spaceY]
    }

    static getRowsCount = (device) => {
        let res = 0;
        ['top', 'top2', 'bottom', 'bottom2'].forEach(rowName => {
            let key = rowName + 'Ports';
            if (device[key] > 0) {
                res++;
            }
        })

        return res;
    }

    static getPortY = (device, position, screwWidth, height) => {
        switch (position) {
            case 'top': {
                return this.getScrewsPaddingY();
            }
            case 'top2': {
                const topPortWidth = this.getScrewWidthAndSpace(device, 'top')[0] * (device.topPorts > 0);
                return topPortWidth + this.getScrewsPaddingY() + this.getRowsSpace();
            }
            case 'bottom2': {
                const bottomPortWidth = this.getScrewWidthAndSpace(device, 'bottom')[0] * (device.bottomPorts > 0);
                return height - bottomPortWidth - this.getScrewsPaddingY() - screwWidth - this.getRowsSpace();
            }
            case 'bottom': {
                return height - screwWidth - this.getScrewsPaddingY();
            }
        }
    }

    static getRowsSpace = () => {
        return 5;
    }

    static getScrewsPaddingY = () => {
        return 20;
    }
}
